import * as React from 'react'

import Icon from 'components/Icon'
import theme from 'theme'

const StyledCheckmark: React.FC = props => {
  return (
    <div
      css={{
        background: theme.colors.blue[0],
        borderRadius: theme.borderRadius[2],
        padding: theme.space[1],
        display: 'grid',
        placeItems: 'center',
        color: theme.colors.white[0]
      }}
      {...props}
    >
      <Icon css={{ display: 'block' }} icon="checkmark" />
    </div>
  )
}

export default StyledCheckmark
